import apiClient from '../apiClient';
import { GET_PAYMENT_METHOD_BY_COUNTRY_ID_URL } from '../apiUrl';

const getPaymentMethodByCountryIdApi = countryId => {
  return apiClient.get(GET_PAYMENT_METHOD_BY_COUNTRY_ID_URL(countryId));
};

export default getPaymentMethodByCountryIdApi;
